export const leadDetailContainerSx = (isCompact: boolean) => ({
  flexGrow: 1,
  flexBasis: 0,
  minWidth: 0,
  height: isCompact ? '100%' : undefined,
  justifyContent: isCompact ? 'center' : undefined,
  boxSizing: 'border-box' as const,
  ...(isCompact ? { py: 1, pr: 1, pl: 1.5 } : { p: 3 }),
});
